/* Lumora home page behaviours. Loaded by sections/lumora-home.liquid. */
(function () {
  function boot() {
    var els = document.querySelectorAll('.lum-rv');

    /* Reveal on scroll. The .lum-anim class is added synchronously in the markup,
       so if scripting is unavailable the content simply stays visible. */
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '300px 0px 300px 0px', threshold: 0 });
      Array.prototype.forEach.call(els, function (e) { io.observe(e); });
    }

    /* Safety net: if anything goes wrong, never leave content hidden. */
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.lum-rv:not(.is-in)'), function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight * 1.5) e.classList.add('is-in');
      });
    }, 2500);

    /* Sticky buy bar. Horizon scrolls an inner container rather than the window,
       so a window scroll listener never fires - observe the hero instead. */
    var bar = document.getElementById('lum-sticky');
    var hero = document.querySelector('.lum-hero');
    var last = document.querySelector('.lum-final');

    if (bar && hero && 'IntersectionObserver' in window) {
      var heroOut = false;
      var endNear = false;
      var apply = function () {
        if (heroOut && !endNear) { bar.classList.add('is-on'); }
        else { bar.classList.remove('is-on'); }
      };
      new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; apply(); },
        { threshold: 0 }).observe(hero);
      if (last) {
        new IntersectionObserver(function (e) { endNear = e[0].isIntersecting; apply(); },
          { threshold: 0 }).observe(last);
      }
    }

    /* Smooth in-page links. */
    Array.prototype.forEach.call(document.querySelectorAll('.lum a[href^="#"]'), function (a) {
      a.addEventListener('click', function (ev) {
        var t = document.querySelector(a.getAttribute('href'));
        if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* FAQ: one answer open at a time. */
    var dets = document.querySelectorAll('.lum-faq details');
    Array.prototype.forEach.call(dets, function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        Array.prototype.forEach.call(dets, function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
